import React, { Fragment } from 'react';
import DropTrackStats from './DropTrackStats';
import ProductBar from './ProductBar';
import Alert from './Alert';
import PriceHistoryGraph from './PriceHistory.Graph';
import { priceHistory } from '../../ChartData';
// import Recommendations from './Recommendations';

function RecommendationsSection() {
    return (
        <>
            <Alert />

            <DropTrackStats />

            <ProductBar />

            <div className="flex mt-3 mx-5">
                <PriceHistoryGraph 
                    priceHistoryData={priceHistory}
                />
            </div>

            {/* <div className="flex mt-3 mx-5">
                <Recommendations />
            </div> */}
        </>
    );
}

export default RecommendationsSection;
